import dayjs from "dayjs";
import { saveAs } from "file-saver";

export const formatRelativeTime = (date) => {
  const mins = Math.round((Date.now() - new Date(date).getTime()) / 60000);
  if (mins < 60) return `${Math.max(mins, 0)} min ago`;
  if (mins < 1440) return `${Math.round(mins / 60)} hrs ago`;
  return dayjs(date).format("D MMM, h:mm A");
};

export const downloadResponsesAsCsv = (rows, filename = "nps-responses.csv") => {
  const header = ["Order ID", "Customer", "Score", "Segment", "Submitted"];
  const escape = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;
  const lines = rows.map((r) =>
    [r.suborder_id, r.reviewer, r.rating, r.segment, dayjs(r.created_at).format("YYYY-MM-DD HH:mm")]
      .map(escape)
      .join(",")
  );
  const csv = [header.map(escape).join(","), ...lines].join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, filename);
};
